<template>
  <v-dialog v-model="isBreakActive" width="400" persistent scrollable>
    <v-card>
      <v-card-title class="pa-0 shadow-1">
        <v-img
          :src="require('@/assets/illustrations/bg_modal_card.svg')"
          cover
          position="left bottom"
          class="align-center"
          height="65px"
        >
          <v-card-title class="font-weight-medium primary--text">
            Pausa iniciada
          </v-card-title>
        </v-img>
      </v-card-title>

      <v-card-text class="pt-3 text-center">
        <p>Iniciado {{ Break.created_at | date }}</p>

        <!-- <div class="my-8">
                    <span class="title primary--text"
                        >Iniciado {{ Break.created_at | date }}</span
                    >
                </div> -->

        <div class="my-8">
          <span class="title primary--text">Finaliza a las</span>
          <h2 class="my-0 display-4">
            {{ finishTime }}
          </h2>

          <p>{{ Break.pause.name }}. Duración: {{ Break.pause.time }}</p>
        </div>

        <span>
          Has iniciado una pausa para continuar con tu jornada pulsa el boton de
          finalizar.
        </span>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="mx-2">
        <v-spacer></v-spacer>
        <v-hover v-slot:default="{ hover }">
          <v-btn
            rounded
            color="success"
            :class="hover ? 'shadow-2' : 'shadow-4'"
            class="px-8"
            @click="continueSession"
          >
            Finalizar pausa
          </v-btn>
        </v-hover>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      value: {},
      chronometer: "00 : 00 : 00",
      counter: 0,
    };
  },

  mounted() {
    // this.setChronometer();
    // this.finishTime();
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },

  computed: {
    ProfileInfo() {
      return this.$store.getters["passport/CURRENT_USER"];
    },

    isBreakActive() {
      return this.$store.getters["breaks/GET_IS_BREACK_ACTIVE"];
    },
    Break() {
      return this.$store.getters["breaks/GET_BREAK"];
    },

    finishTime() {
      const created_at = new Date(this.Break.created_at);
      const momentObj = moment(created_at);
      const duration = this.Break.pause.time;
      const finishDateTime = momentObj.add(moment.duration(duration));
      const finishTime = moment(finishDateTime).format("HH:mm");

      return finishTime;
    },
  },

  filters: {
    date(value) {
      return moment(value)
        .locale("es")
        .calendar();
    },
    // date1(value) {
    //     return moment(value)
    //         .locale("es")
    //         .format("LTS");
    // }
  },

  methods: {
    // setChronometer() {
    //   this.interval = setInterval(() => {
    //     this.chronometer = moment()
    //       .hour(0)
    //       .minute(0)
    //       .second(this.counter)
    //       .format("HH : mm : ss");
    //     this.counter++;
    //   }, 1000);
    // },

    async continueSession() {
      try {
        this.$store.commit("layout/SET_OVERLAY", {
          value: true,
          title: "Activando sesion",
        });
        const idPause = this.$store.getters["breaks/GET_BREAK"].id;

        await this.$store.dispatch("breaks/CONTINUE_SESSION", {
          id: idPause,
        });

        this.$store.dispatch("dialer/SET_IS_CONNECTED", true);

        setTimeout(async () => {
          await this.connect(this.ProfileInfo.extension);
          this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
        }, 5000);

        this.$snotify.success("Puede continuar con su jornada de trabajo.", "¡Hecho!");
        this.counter = 0;
        this.$store.dispatch("breaks/SHOW_BREAKS_AGENTS");
      } catch (error) {
        alert("Su Sesion ha sido Bloqueada");
        this.$store.commit("breaks/SET_ACTIVE_BREAK", {});
        localStorage.clear();
        this.$router.push({ name: "login" });
        this.counter = 0;
      }
    },
    async connect(extension) {
      try {
        const res = await this.$store.dispatch(
          "passport/RESET_CONNECTION_AGENT",
          extension
        );

        if (res.status === 200) {
          for (const client of res.data) {
            switch (client.codigo) {
              case "Added":
                this.$snotify.success(`${client.message}`, `Cola ${client.queue}`);

                break;

              case "Command":
                this.$snotify.error(`Cola ${client.queue}: ${client.message}`, "¡Error!");

                break;

              case "Removed":
                this.$snotify.success(`${client.message}`, `Cola ${client.queue}`);

                break;
            }
          }
          this.GetProfileInfo();
        }
      } catch (error) {
        // console.error(error);
        this.$snotify.error("Error al conectar a planta.", "Error 500");
      }
    },
    async GetProfileInfo() {
      try {
        await this.$store.dispatch("passport/ACTIVE_USER");
      } catch (error) {
        console.error("error al obtener perfil", error);
      }
    },
  },
};
</script>

<style></style>
